class FoodCalculator extends HTMLElement {
  constructor() {
    super();

    this.currentQuestion = 1;
    this.buttons = this.querySelectorAll(".js-question-toggle");
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        this.handleButtonClick(e, button);
      });
    });

    this.trackerItems = this.querySelectorAll(".js-tracker-item");

    this.dailyCalories = 0;
    this.dailyPackage = 0;

    this.packageType = window.calculatorStrings.productType
      ? window.calculatorStrings.productType
      : window.calculatorStrings.pouch;
    this.packageSize = window.calculatorStrings.productSize
      ? window.calculatorStrings.productSize
      : 0;
    this.productKCal = window.calculatorStrings.productKCal
      ? window.calculatorStrings.productKCal
      : 0;

    this.savedPetsSelect = this.querySelector(".js-saved-pets");
    if (this.savedPetsSelect) {
      this.savedPetsSelect.addEventListener("change", (e) => {
        this.answers = window.savedPets[e.target.value];
        this.calculateSavedPet();
        this.gotoQuestion(7);
        this.updateTracker();
      });
    }

    this.calculatorInput = this.querySelector(
      '.formful__wrapper input[data-label="Calculator Pet"]'
    );

    const dobInput = this.querySelector(".food-calculator__dob input");
    if (dobInput) {
      dobInput.max = new Date().toISOString().split("T")[0];
    }
  }

  handleButtonClick(event, button) {
    if (button.classList.contains("js-submit")) {
      const form = button.closest("form");
      if (form && form.classList.contains("js-validate-answer")) {
        event.preventDefault();
        const isValid = this.validateAnswer(form);
        if (!isValid) {
          this.showError();
          return;
        }
      } else if (form && !form.checkValidity()) {
        return;
      } else {
        event.preventDefault();
      }
    }

    const goTo = parseFloat(button.getAttribute("data-to-question"));
    if (goTo > this.currentQuestion) {
      this.goToNextQuestion();
    } else if (goTo < this.currentQuestion) {
      this.goToPrevQuestion();
    }

    this.updateTracker();
    this.storeAnswers();
  }

  goToPrevQuestion() {
    const thisQ = this.querySelector(
      `[data-question="${this.currentQuestion}"]`
    );
    const prevQ = this.querySelector(
      `[data-question="${this.currentQuestion - 1}"]`
    );

    if (thisQ) {
      thisQ.style.left = `0`;
    }
    if (prevQ) {
      prevQ.style.left = `-${(this.currentQuestion - 2) * 100}%`;
    }

    this.currentQuestion--;
  }

  goToNextQuestion() {
    const thisQ = this.querySelector(
      `[data-question="${this.currentQuestion}"]`
    );
    const nextQ = this.querySelector(
      `[data-question="${this.currentQuestion + 1}"]`
    );

    if (thisQ) {
      thisQ.style.left = `-${this.currentQuestion * 100}%`;
    }
    if (nextQ) {
      nextQ.style.left = `-${this.currentQuestion * 100}%`;
    }

    this.currentQuestion++;
  }

  gotoQuestion(questionNumber) {
    const thisQ = this.querySelector(
      `[data-question="${this.currentQuestion}"]`
    );
    const nextQ = this.querySelector(`[data-question="${questionNumber}"]`);

    if (thisQ) {
      thisQ.style.left = `-${this.currentQuestion * 100}%`;
    }
    if (nextQ) {
      nextQ.style.left = `-${(questionNumber - 1) * 100}%`;
    }

    this.currentQuestion = questionNumber;
  }

  updateTracker() {
    this.trackerItems.forEach((item, index) => {
      if (index >= this.currentQuestion) {
        item.classList.remove("active");
      } else {
        item.classList.add("active");
      }
    });

    this.trackerWidth =
      (100 / (this.trackerItems.length - 1)) * (this.currentQuestion - 1);

    this.style.setProperty(
      "--food-calculator-tracker-width",
      `${this.trackerWidth}%`
    );
  }

  toggleQuestionRoute(routeToShow) {
    if (routeToShow == "a") {
      this.querySelectorAll(".js-show-route-a").forEach((item) => {
        item.classList.remove("hidden");
      });
      this.querySelectorAll(".js-show-route-b").forEach((item) => {
        item.classList.add("hidden");
      });
    } else if (routeToShow == "b") {
      this.querySelectorAll(".js-show-route-b").forEach((item) => {
        item.classList.remove("hidden");
      });
      this.querySelectorAll(".js-show-route-a").forEach((item) => {
        item.classList.add("hidden");
      });
    } else if (routeToShow == "c") {
      this.querySelectorAll(".js-show-route-c").forEach((item) => {
        item.classList.remove("hidden");
      });
      this.querySelectorAll(".js-show-route-d").forEach((item) => {
        item.classList.add("hidden");
      });
    } else if (routeToShow == "d") {
      this.querySelectorAll(".js-show-route-c").forEach((item) => {
        item.classList.add("hidden");
      });
      this.querySelectorAll(".js-show-route-d").forEach((item) => {
        item.classList.remove("hidden");
      });
    }
  }

  toggleCatDogAnswers() {
    if (this.answers[window.calculatorStrings.petType] == "Cat") {
      this.querySelectorAll(".js-show-cat").forEach((item) => {
        item.classList.remove("hidden");
      });
      this.querySelectorAll(".js-show-dog").forEach((item) => {
        item.classList.add("hidden");
      });
    } else if (this.answers[window.calculatorStrings.petType] == "Dog") {
      this.querySelectorAll(".js-show-cat").forEach((item) => {
        item.classList.add("hidden");
      });
      this.querySelectorAll(".js-show-dog").forEach((item) => {
        item.classList.remove("hidden");
      });
    }
  }

  storeAnswers() {
    this.answers = {};
    this.querySelectorAll("input[type='radio']:checked").forEach((input) => {
      this.answers[input.getAttribute("data-field-name")] = input.value;
    });
    this.querySelectorAll("input[type='text']").forEach((input) => {
      this.answers[input.getAttribute("data-field-name")] = input.value;
    });
    this.querySelectorAll("input[type='date']").forEach((input) => {
      this.answers[input.getAttribute("data-field-name")] = input.value;
    });

    if (this.querySelector(".js-current-weight-input").value != "") {
      this.answers[window.calculatorStrings.currentWeight] = parseFloat(
        this.querySelector(".js-current-weight-input").value
      );
    } else if (this.querySelector(".js-current-weight-select").value != "") {
      this.answers[window.calculatorStrings.currentWeight] = parseFloat(
        this.querySelector(".js-current-weight-select").value
      );
    }

    if (this.querySelector(".js-expected-weight-input").value != "") {
      this.answers[window.calculatorStrings.expectedWeight] = parseFloat(
        this.querySelector(".js-expected-weight-input").value
      );
    } else if (this.querySelector(".js-expected-weight-select").value != "") {
      this.answers[window.calculatorStrings.expectedWeight] = parseFloat(
        this.querySelector(".js-expected-weight-select").value
      );
    }

    //toggle cat/dog answers
    this.toggleCatDogAnswers();

    //toggle question routes
    if (this.answers[window.calculatorStrings.petAge]) {
      if (this.answers[window.calculatorStrings.petAge].includes("Kitten")) {
        this.toggleQuestionRoute("a");
      } else {
        this.toggleQuestionRoute("b");
      }
    }

    if (this.answers[window.calculatorStrings.petAge]) {
      if (this.answers[window.calculatorStrings.petAge].includes("Puppy")) {
        this.toggleQuestionRoute("c");
      } else {
        this.toggleQuestionRoute("d");
      }
    }

    this.calculateAllowance(this.answers);
    this.answers[window.calculatorStrings.dailyCalories] = this.dailyCalories;
    this.answers[window.calculatorStrings.dailyProduct] = this.dailyPackage;

    // Save data to sessionStorage
    sessionStorage.setItem("petFoodCalculator", JSON.stringify(this.answers));

    this.calculatorInput.value = JSON.stringify(this.answers);

    this.updateFormData();
  }

  updateFormData() {
    this.querySelectorAll(".js-pets-name").forEach((name) => {
      name.innerHTML = this.answers["Pets Name"];
    });

    this.querySelectorAll(".js-daily-calories").forEach((calories) => {
      calories.innerHTML = this.answers[window.calculatorStrings.dailyCalories];
    });

    this.querySelectorAll(".js-daily-product").forEach((pouches) => {
      pouches.innerHTML = this.answers[window.calculatorStrings.dailyProduct];
    });

    this.querySelectorAll(".js-product-package-type").forEach((type) => {
      type.innerHTML = this.packageType;
    });
  }

  calculateAllowance(pet) {
    //check which pet is selected
    if (pet["Pet type"] == "Dog") {
      if (pet["Pet age"] == "Puppy (2 Months - 1 Year)") {
        this.calculatePuppy(pet);
      } else {
        this.calculateDog(pet);
      }
    } else if (pet["Pet type"] == "Cat") {
      if (pet["Pet age"] == "Kitten (2 Months - 1 Year)") {
        this.calculateKitten(pet);
      } else {
        this.calculateCat(pet);
      }
    }

    this.calculateProductAmount();
  }

  calculatePuppy(pet) {
    const currentWeight = pet[window.calculatorStrings.currentWeight];
    const adultWeight = pet[window.calculatorStrings.expectedWeight];
    const weightCalculation = currentWeight / adultWeight;

    this.dailyCalories = Math.round(
      (254.1 - 135 * weightCalculation) * Math.pow(currentWeight, 0.75)
    );
  }

  calculateDog(pet) {
    const lowActivityCalories = window.calculatorStrings.dogLowActivityCalories;
    const moderateActivityCalories =
      window.calculatorStrings.dogModerateActivityCalories;
    const highActivityCalories =
      window.calculatorStrings.dogHighActivityCalories;

    let caloriesToUse = lowActivityCalories;
    if (pet["Activity level"] == "Moderate") {
      caloriesToUse = moderateActivityCalories;
    } else if (pet["Activity level"] == "High") {
      caloriesToUse = highActivityCalories;
    }

    const currentWeight = pet[window.calculatorStrings.currentWeight];

    this.dailyCalories = Math.round(
      caloriesToUse * Math.pow(currentWeight, 0.75)
    );
  }

  calculateKitten(pet) {
    this.kittenCalories = window.calculatorStrings.kittenCalories;
    if (pet[window.calculatorStrings.kittenMonths]) {
      const monthsOld = parseFloat(pet[window.calculatorStrings.kittenMonths]);

      this.dailyCalories = this.kittenCalories[monthsOld];
    }
  }

  calculateCat(pet) {
    const indoorActivityCalories =
      window.calculatorStrings.catIndoorActivityCalories;
    const outdoorActivityCalories =
      window.calculatorStrings.catOutdoorActivityCalories;

    let caloriesToUse = indoorActivityCalories;
    if (pet["Activity level"] == window.calculatorStrings.outdoorAnswer) {
      caloriesToUse = outdoorActivityCalories;
    }

    const currentWeight = pet[window.calculatorStrings.currentWeight];
    this.dailyCalories = Math.round(
      caloriesToUse * Math.pow(currentWeight, 0.67)
    );

    this.packageType = window.calculatorStrings.pouch;
  }

  calculateProductAmount() {
    const kcalKg = this.productKCal * 10;

    const dailyAmountToFeed = (this.dailyCalories * 1000) / kcalKg;
    const numberOfPackageToFeed = dailyAmountToFeed / this.packageSize;

    this.dailyPackage = Math.ceil(numberOfPackageToFeed / 0.25) * 0.25;
  }

  calculateSavedPet() {
    this.calculateAllowance(this.answers);
    this.answers[window.calculatorStrings.dailyCalories] = this.dailyCalories;
    this.answers[window.calculatorStrings.dailyProduct] = this.dailyPackage;
    this.updateFormData();
  }

  validateAnswer(form) {
    let isValid = false;
    form.querySelectorAll("input[type='text']").forEach((input) => {
      if (input.value.length && !input.closest(".hidden")) {
        isValid = true;
      }
    });

    form.querySelectorAll("input[type='number']").forEach((input) => {
      if (input.value.length && !input.closest(".hidden")) {
        isValid = true;
      }
    });

    form.querySelectorAll("input[type='radio']").forEach((input) => {
      if (input.checked && !input.closest(".hidden")) {
        isValid = true;
      }
    });

    form.querySelectorAll("select").forEach((input) => {
      if (input.value.length && !input.closest(".hidden")) {
        isValid = true;
      }
    });

    return isValid;
  }

  showError() {
    this.querySelector(".js-error-message").classList.add("active");
    setTimeout(() => {
      this.querySelector(".js-error-message").classList.remove("active");
    }, 3000);
  }
}

customElements.define("food-calculator", FoodCalculator);
